export const AdminPrefix = '/admin'

export const AdminPath = {
  AdminDashboard: '/dashboard',
  AdminHoardings: '/hoardings',
  AdminQuotations: '/quotations',
  AdminCampaigns: '/campaigns',
  AdminVendors: '/vendors',
  AdminSettings: '/settings',
}
